// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// To-Do: Move these secrets to ENV VARS
export const environment = {
  production: false,
  stage: 'Development',
  apiUrl: 'https://backend.ttc-cruise-dev.smartrates.dynamica.engine.simon-kucher.com/api',
  Authority_URL:'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_QN75CxmkX',
  Client_ID: '22qrnhivam6vt98qvj3mqe1b3v',
  project:"cruise" // folder name
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
